module.exports = __webpack_public_path__ + "static/digitalteeth-55d729a2a70e6c297885fc6b922ec60b.jpg";